import React from 'react';

export default function WritingSection(){
  return (
    <div className='content-section'  id='section-writing'>
      <div className='content-header'>writing</div>
      <div className='content-body'>
        <p>
          Twilio blog post on <a href='https://www.twilio.com/blog/high-volume-messaging-solution' target='_blank' rel="noreferrer">architecting a scalable Programmable Messaging solution</a>
        </p>
        <p>
          Twilio blog post on <a href='https://www.twilio.com/blog/add-custom-attributes-twilio-sms-campaigns' target='_blank' rel="noreferrer">attaching metadata to Programmable Messaging</a>
        </p>
        <p>
          Twilio blog post on <a href='https://www.twilio.com/blog/passing-context-between-google-dialogflow-and-twilio-studio' target='_blank' rel="noreferrer">transferring data between IVR phone systems and Google Dialogflow</a>
        </p>
        <p>
          <a href='https://medium.com/@kristajg' target='_blank' rel="noreferrer">Medium articles</a> about technology, humor
        </p>
        {/* <p>
          This lil poem: 
        </p> */}
      </div>
    </div> 
  )
}
